
export const formatDate = (dateISOString: string) => {
  if (dateISOString == undefined) return;
  var date = new Date(dateISOString);
  var _dd;
  var _mm;
  var _yy = date.getFullYear();

  date.getDate() < 10 ? (_dd = "0" + date.getDate()) : (_dd = date.getDate());
  _mm =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;

  return _dd + "/" + _mm + "/" + _yy;
};

export const formatDateTime = (dateISOString: string | undefined) => {
  if (dateISOString == undefined) return;
  var date = new Date(dateISOString);
  var _dd;
  var _mm;
  var _yy = date.getFullYear();
  var _hh;
  var _mintue;

  date.getDate() < 10 ? (_dd = "0" + date.getDate()) : (_dd = date.getDate());
  _mm =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;

  _hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();

  _mintue =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  return _dd + "/" + _mm + "/" + _yy + " " + _hh + ":" + _mintue;
};

export const formatTime = (dateISOString: string | undefined) => {
  if (dateISOString == undefined) return;
  var date = new Date(dateISOString);
  var _hh;
  var _mintue;

  _hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();

  _mintue =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  return _hh + ":" + _mintue;
};

export const dateTimeToTimeStr = (dateTime: Date) => {
  var hours: string | number = dateTime.getHours()
  var minutes: string | number = dateTime.getMinutes()

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;

  return hours + ":" + minutes + ":00"
}

export const dateTimeToTimeStr2 = (dateTime: Date) => {
  var hours: string | number = dateTime.getHours()
  var minutes: string | number = dateTime.getMinutes()

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;

  return hours + ":" + minutes
}

// return a Date Object that has a current time value in HK time zone
export const generateACurrentDateTimeInUTF8 = () => {
  return new Date(Date.now() + 8 * 60 * 60 * 1000);
}